import moment from "moment-timezone";
import { applyTimezone } from "../../../../../utils/helpers/date";

export const formatSubmittedData = (values) => ({
    ...values,
    // periodStartDate: moment(values?.periodStartDate).format(
    //     "YYYY-MM-DDTHH:mm:ss",
    // ),
    // periodEndDate: applyTimezone(values?.periodEndDate).format(
    //     "YYYY-MM-DDTHH:mm:ss",
    // ),
    periodStartDate: moment(values?.periodStartDate).utc().toISOString(true),
    periodEndDate: moment(values?.periodEndDate).utc().toISOString(true),
    country: values?.country?.id,
    timeSheetLockDate: Number(values?.timeSheetLockDate),
});
